import { useState } from "react";

import { RiFileExcel2Fill } from "react-icons/ri";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";

import { timeToString } from "@/utils/dateUtil";
import { exportExcel } from "@/utils/exports";
import { ResumeGrouped } from "@/services/esus/attendanceService";
import { GenericObject } from "@/@types/generics/genericals";
import { User } from "@/@types/sintegrada/User";

import { BaseModalProps } from "@/components/BaseModal";
import AttendanceByProfessionalTable from "../AttendanceByProfessionalTable";

type Props = BaseModalProps & {
	aggregatedByProfessionalsAndRiskClassificationStatus: ResumeGrouped<
		User,
		ResumeGrouped<"Reclassificações" | "Classificações", object>
	>[];
	averageTimeInSecondsByProfessional: ResumeGrouped<User, object>[];
};

export function AttendanceByProfessionalModal({
	aggregatedByProfessionalsAndRiskClassificationStatus,
	averageTimeInSecondsByProfessional,
	...rest
}: Props) {
	const [isLoadingExportExcel, setIsLoadingExportExcel] = useState(false);

	function handleExportTable() {
		setIsLoadingExportExcel(true);
		if (Object.keys(aggregatedByProfessionalsAndRiskClassificationStatus || []).length) {
			const excelData: GenericObject[] = transformDataToExportExcel(
				aggregatedByProfessionalsAndRiskClassificationStatus
			);
			exportExcel(excelData, `Tabela`);
		}
		setIsLoadingExportExcel(false);
	}

	function transformDataToExportExcel(
		professionalGroups: ResumeGrouped<
			User,
			ResumeGrouped<"Reclassificações" | "Classificações", object>
		>[]
	) {
		return professionalGroups.map(
			(aggregatedProfessional) =>
				({
					Profissional: aggregatedProfessional.key.name ?? "N/A",
					classificações:
						(aggregatedProfessional.values || []).find(
							(classificatedAttendances) =>
								classificatedAttendances.key === "Classificações"
						)?.total || 0,
					Reclassificação:
						(aggregatedProfessional.values || []).find(
							(classificatedAttendances) =>
								classificatedAttendances.key === "Reclassificações"
						)?.total || 0,
					"Tempo médio de atendimento": timeToString(
						averageTimeInSecondsByProfessional.find(
							(professionalGroup) =>
								professionalGroup.key.id === aggregatedProfessional.key.id
						)?.total || 0
					),
				} as GenericObject)
		);
	}
	return (
		<Modal size="xl" scrollable {...rest}>
			<Modal.Header className="d-flex justify-content-between" closeButton>
				<Modal.Title>Atendimentos por profissional</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Row className="d-flex justify-content-end">
					<Col sm={2} md={2} lg={2} xl={2} className="d-flex justify-content-end">
						<Button
							className="justify-content-end"
							variant="secondary"
							onClick={handleExportTable}
							disabled={isLoadingExportExcel}
						>
							<RiFileExcel2Fill />
							Exportar
						</Button>
					</Col>
				</Row>
				<Row className="p-2">
					<AttendanceByProfessionalTable
						aggregatedByProfessionalsAndRiskClassificationStatus={
							aggregatedByProfessionalsAndRiskClassificationStatus
						}
						averageTimeInSecondsByProfessional={averageTimeInSecondsByProfessional}
					/>
				</Row>
			</Modal.Body>
		</Modal>
	);
}
